<template>
    <table
        class="table align-middle table-nowrap mb-0"
        id="customerTable"
    >
        <thead class="table-light">
        <tr>
            <th>محصول</th>
            <th>انبار</th>
            <th>قیمت</th>
            <th>کد یکتا</th>
            <th>sku</th>
        </tr>
        </thead>
        <tbody class="list form-check-all">
        <tr class="gridjs-tr" v-for="(data, index) of resultQuery" :key="index">
            <td data-column-id="product" class="gridjs-td">
                            <span>
                              <div class="d-flex align-items-center">
                                <div class="flex-shrink-0 me-3">
                                  <div class="avatar-sm bg-light rounded p-1">
                                    <img :src="data.image" alt="" class="img-fluid d-block"/>
                                  </div>
                                </div>
                                <div class="flex-grow-1">
                                  <h5 class="fs-14 mb-1">
                                    <router-link to="/ecommerce/product-details" class="text-dark">{{ data.name }}</router-link>
                                  </h5>
                                </div>
                              </div>
                            </span>
            </td>
            <td data-column-id="stock" class="gridjs-td">{{ stockStatusStr(data.stock_status) }}</td>
            <td data-column-id="price" class="gridjs-td" v-html="data.price_html"></td>
            <td data-column-id="pid" class="gridjs-td">{{ data.id }}</td>
            <td data-column-id="sku" class="gridjs-td">{{ data.sku }}</td>
        </tr>
        </tbody>


    </table>
</template>

<script>
export default {
    name: "product-list",
    props: ['resultQuery'],
    methods: {

        stockStatusStr(id) {
            if (id === 'instock') return 'موجود'
            if (id === 'outofstock') return 'ناموجود'
            if (id === 'preorder') return 'در پیش سفارش'
            return 'نا مشخص'
        },
        categoryStr(catObject) {
            return catObject[0].name
        },
    }
}
</script>

<style scoped>

</style>
